import { connect, ConnectedProps } from 'react-redux';

import {
    setConsideredMobile,
    setConsideredMedium,
} from '../state/actions';

import {
    IPropyCookieValue,
} from '../interfaces';

import App from '../components/App';

interface RootState {
    darkMode: boolean;
    consentToCookies: boolean;
    propyCookieValue: string;
}
  
const mapStateToProps = (state: RootState) => ({
    darkMode: state.darkMode,
    propyCookieValue: JSON.parse(state.propyCookieValue) as IPropyCookieValue,
})

const mapDispatchToProps = {
    setConsideredMobile,
    setConsideredMedium,
}

const connector = connect(mapStateToProps, mapDispatchToProps)
  
export type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(App)